import React from 'react';

import { ADFS_APP_FIELDS } from '../../common/fields';
import SelectField from '../Controls/SelectField/SelectField';
import TextInput from '../Controls/TextInput/TextInput';

import styles from './FederatedApps.module.css';
import { SUBCATEGORIES } from '../../common/categories';

const { PROTOCOL, NAME, IDENTIFIER } = ADFS_APP_FIELDS;

const ADFSApp = ({ adfsApp, changedFunc, disabled = false }) => {
    return (
        <div className={`${styles.federatedApp}${disabled ? ' ' + styles.disabled : ''}`}>
            <SelectField
                field={adfsApp[PROTOCOL.ID]}
                color="grey"
                changed={changedFunc}
                disabled={disabled}
                options={[{ value: 'SAML', label: 'SAML' }]}
                featureLockId={SUBCATEGORIES.ADFS_FEDERATED_APPS.ID}
                featureLockIsTabId={true}
            />
            <TextInput
                field={adfsApp[NAME.ID]}
                disabled={disabled}
                color="grey"
                changed={changedFunc}
                featureLockId={SUBCATEGORIES.ADFS_FEDERATED_APPS.ID}
                featureLockIsTabId={true}
            />
            <TextInput
                field={adfsApp[IDENTIFIER.ID]}
                disabled={disabled}
                color="grey"
                changed={changedFunc}
                featureLockId={SUBCATEGORIES.ADFS_FEDERATED_APPS.ID}
                featureLockIsTabId={true}
            />
        </div>
    );
};

export default React.memo(ADFSApp);
